import "./kendo.html.base.js";

export const __meta__ = {
    id: "html.loadercontainer",
    name: "Html.LoaderContainer",
    category: "web",
    description: "HTML rendering utility for Kendo UI for jQuery.",
    depends: [ "html.base"],
    features: []
};

(function($, undefined) {
    const kendo = window.kendo,
        HTMLBase = kendo.html.HTMLBase,
        encode = kendo.htmlEncode;

    const renderLoaderContainer = function(element, options) {
        if (!element || $.isPlainObject(element)) {
            options = element;
            element = $("<div></div>");
        }

        return (new HTMLLoaderContainer(element, options)).html();
    };

    const LOADER_CONTAINER = "k-loader-container k-loader-container-lg",
        LOADER_OVERLAY = "k-loader-container-overlay";


    const HTMLLoaderContainer = HTMLBase.extend({
        init: function(element, options) {
            const that = this;

            HTMLBase.fn.init.call(that, element, options);

            that._wrapper();
            that._overlay();
            that._innerContainer();
        },
        options: {
            name: "HTMLLoaderContainer",
            themeColor: undefined,
            cssClass: '',
            message: 'Loading...',
            loaderPosition: 'start',
        },

        _wrapper: function() {
            const options = this.options;

            this.wrapper = $(`<div class="${LOADER_CONTAINER} k-loader-${encode(options.loaderPosition)}${options.cssClass ? ` ${encode(options.cssClass)}` : ''}"></div>`);
        },

        _overlay: function() {
            const overlay = $(`<div class='${LOADER_OVERLAY} k-overlay'></div>`);

            this.wrapper.append(overlay);
        },

        _innerContainer: function() {
            const innerContainer = $("<div class='k-loader-container-inner k-loader-container-panel'></div>"),
                message = this._initMessage();

            this.loaderContainer = innerContainer;

            innerContainer.append(message);
            this.wrapper.append(innerContainer);
        },

        _initMessage: function() {
            const message = encode(this.options.message),
                themeColor = encode(this.options.themeColor),
                messageContainer = $(`<div class='k-loader-container-label !k-text-${themeColor}'>${message}</div>`);

            return messageContainer;
        }
    });

    $.extend(kendo.html, {
        renderLoaderContainer: renderLoaderContainer,
        HTMLLoaderContainer: HTMLLoaderContainer
    });

})(window.kendo.jQuery);
export default kendo;